<template>
    <div id="favorite">
        <!-- <van-nav-bar
                title="我的收藏"
                :fixed="true"
                left-arrow
                @click-left="$router.go(-1)"
        /> -->
        <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad"
        >
            <div class="list" v-for="item in list" :key="item.documentId" @click="$router.push(`/article/detail/${item.documentId}`)">
                <div>
                    <h5>{{ item.name }}</h5>
                    <span>{{ item.createTime || '2018-2-3'}}</span>
                </div>
                <img class="avatar" v-lazy="item.thumbnail + '?imageView2/1/w/82/h/72'" />
            </div>
        </van-list>
        <list-foot v-if="isError">出错了</list-foot>
        <list-foot v-else-if="hasLoaded && list.length === 0">没有数据</list-foot>
        <list-foot v-else-if="finished">到底了</list-foot>
    </div>
</template>

<script>
  import ListFoot from '@/components/ListFoot';
  import {NavBar, List, Lazyload, Cell} from 'vant';

  const LazyloadOptions = {
    loading: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82',
    // error: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82',
    preload: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/80/h/82'
  };
  import Vue from 'vue'
  Vue.use(NavBar).use(List).use(Lazyload, LazyloadOptions).use(Cell);
  export default {
    name: 'UserFavorite',
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        hasLoaded: false,
        isError: false
      };
    },
    components: {ListFoot},
    methods: {
      onLoad() {
        this.list = this.$store.state.userInfo.favorite;
        this.finished = true;
        this.loading = false;
        this.hasLoaded = true;
      }
    }
  };
</script>

<style scoped lang="less">
    #favorite {
        /deep/ .van-nav-bar .van-icon {
            color: black;
        }
        .list {
            height: 96px;
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            padding: 5px;
            border-bottom: 1px solid #eee;
            span {
              font-size: 14px;
                color: #989898;
            }
        }
    }
</style>